import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

type Props = {
  title?: string;
  description?: string;
  isOpen: boolean;
  onAction: (confirmed: boolean) => void;
};

export const ConfirmDeleteAlert = ({
  title = 'Are you absolutely sure?',
  description = 'This action cannot be undone. This will permanently delete this resource.',
  isOpen,
  onAction,
}: Props) => {
  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onAction(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => onAction(true)}>Continue</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
